var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"fixed":"","app":"","height":"74px"}},[[_c('v-btn',{staticClass:"btn",attrs:{"block":"","large":""},on:{"click":_vm.openDiningModeDialog}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_vm._v("\n          Change Dining Mode\n        ")])],1)],1)]],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b949fc0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupFooter.vue
// module id = pDFs
// module chunks = 0